import ApiService from "../../../ApiService";

const ListService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/list/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    deleteHomework: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/list/delete", vo, successCallback, failureCallback);
    }
};

export default ListService;